import React from "react";
import Logo from "./Icons/Logo";

const Loader = () => {
  return (
    <div className="flex justify-center items-center h-screen bg-[#f4f5f7]">
      <div className="relative w-[200px] h-[200px]">
        <div className="absolute inset-0">
          <svg className="w-full h-full animate-spin" viewBox="0 0 200 200">
            <defs>
              <linearGradient
                id="loaderGradient"
                x1="0%"
                y1="0%"
                x2="100%"
                y2="100%"
              >
                <stop offset="10%" stopColor="#5A8DF1" />
                <stop offset="50%" stopColor="#5A8DF1" />
                <stop offset="100%" stopColor="#F9FAFB" />
              </linearGradient>
            </defs>
            <circle
              cx="100"
              cy="100"
              r="90"
              fill="none"
              stroke="url(#loaderGradient)"
              strokeWidth="12"
              strokeLinecap="round"
              strokeDasharray="550"
              strokeDashoffset="100"
            />
          </svg>
        </div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  w-[100px] h-[100px] flex items-center justify-center ">
          <Logo size={100} />
        </div>
      </div>
    </div>
  );
};

export default Loader;

